<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员登记" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="技术人员登记">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记表编号">
                                            <a-input ref="djsqbbh" v-model="editData.djsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="姓名" required :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="xm" v-model="editData.xm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="image-container">
                                            <UploadImage :attachCfg="attachCfg_Edit" />
                                        </div>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="性别" required>
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="民族" required :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="出生日期" required>
                                            <a-date-picker
                                                ref="csrq"
                                                v-model="editData.csrq"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                :disabledDate="disabledDate"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="区域编号" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="证件类型" required :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="证件号码" required>
                                            <a-input ref="zjhm" v-model="editData.zjhm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="所属单位编号" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="ssdwbh" v-model="editData.ssdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="所属单位名称">
                                            <a-input ref="ssdwmc" v-model="editData.ssdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="人员类别" required>
                                            <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职务">
                                            <a-input ref="zw" v-model="editData.zw" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职称">
                                            <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职称专业">
                                            <a-input ref="zczy" v-model="editData.zczy" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="批准时间">
                                            <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="毕业院校" required>
                                            <a-input ref="byyx" v-model="editData.byyx" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="毕业时间" required>
                                            <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="所学专业" required>
                                            <a-input ref="sxzy" v-model="editData.sxzy" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="学历" required>
                                            <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="学位">
                                            <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="参加工作时间" required>
                                            <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="从业时间">
                                            <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="移动电话">
                                            <a-input ref="yddh" v-model="editData.yddh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="24">
                                        <a-form-item label="个人简历" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="grjl" :rows="3" v-model="editData.grjl" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="上岗证编号">
                                            <a-input ref="sgzbh" v-model="editData.sgzbh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记状态" required>
                                            <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="editData.zczt" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row v-if="editData.zczt === '已登记'" :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="执业资格证书编号" required>
                                            <a-input ref="zyzgzsbh" v-model="editData.zyzgzsbh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记单位编号">
                                            <a-input ref="zcdwbh" v-model="editData.zcdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row v-if="editData.zczt === '已登记'" :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记单位名称" required>
                                            <a-input ref="zcdwmc" v-model="editData.zcdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记时间" required>
                                            <a-date-picker ref="zcsj" v-model="editData.zcsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记周期(年)">
                                            <a-input-number ref="zczq" v-model="editData.zczq" style="width:100%" disabled :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="首次登记时间">
                                            <a-date-picker
                                                ref="sczcsj"
                                                v-model="editData.sczcsj"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                @change="onChange(editData.sczcsj)"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="下次登记时间">
                                            <a-date-picker
                                                ref="xczcsj"
                                                v-model="editData.xczcsj"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                                placeholder=""
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记证(执业专用证)编号">
                                            <a-input ref="zczbh" v-model="editData.zczbh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="主专业">
                                            <a-input-search ref="zzy" readOnly @search="showZzy" v-model="editData.zzy" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_zzy"
                                                selectNo="RY200601"
                                                @saveselect="saveEvent_zzy(arguments, editData)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="辅专业">
                                            <a-input-search ref="fzy" readOnly @search="showFzy" v-model="editData.fzy" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_fzy"
                                                selectNo="RY200601"
                                                @saveselect="saveEvent_fzy(arguments, editData)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="备注">
                                            <a-input ref="bz" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="24">
                                        <a-form-item label="温馨提示" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <span
                                                >请依次上传三证合一(身份证、职称证、毕业证)扫描页、资格证书首次登记页扫描页、传资格证书再登记扫描页、资格证书单位变更扫描页、资格证书专业变更扫描页等相关材料。</span
                                            >
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="技术人员培训记录">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertPXJL">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemPXJLTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemPXJLData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column
                                        field="bjmc"
                                        title="班级名称"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bjmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="bjlb"
                                        title="班级类别"
                                        align="center"
                                        header-class-name="required"
                                        width="130px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="bjlb" dictNo="RY200101" v-model="scope.row.bjlb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="ksrq"
                                        title="报名开始日期"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="ksrq" v-model="scope.row.ksrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="jsrq"
                                        title="报名结束日期"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jsrq" v-model="scope.row.jsrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="pxksrq"
                                        title="培训开始日期"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="pxksrq" v-model="scope.row.pxksrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="pxjsrq"
                                        title="培训结束日期"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="pxjsrq" v-model="scope.row.pxjsrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="pxnr"
                                        title="培训内容"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.pxnr" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="pxdd"
                                        title="培训地点"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.pxdd" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="xs"
                                        title="学时"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input-number ref="xs" v-model="scope.row.xs" :min="0" :precision="1" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="sfhg"
                                        title="是否合格"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="sfhg" dictNo="RY200102" v-model="scope.row.sfhg" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="zsbh"
                                        title="证书编号"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zsbh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="bz"
                                        title="备注"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column title="操作" width="70" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removePXJL(scope.row)">删除</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload ref="attachup" :isnew="editData.isnew" :attachCfg="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "JsrydjEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            tableData: [],
            // 培训记录明细数据
            editItemPXJLData: [],
            editItemPXJLDataLoading: false,
            isShow_qybh: false,
            isShow_qymc: false,
            isShow_zzy: false,
            isShow_fzy: false,
            isShow_ssdwbh: false,
            isShow_ssdwmc: false,
            isShow_zcdwbh: false,
            isShow_zcdwmc: false,
            // 流程跟踪参数
            historyProcessProps: {
                visible: false,
                billid: "",
                instanceId: "",
                processKey: "DJSQBBH"
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        get_gddh() {
            return this.editData.gddh;
        },
        get_yddh() {
            return this.editData.yddh;
        },
        get_zjhm() {
            return this.editData.zjhm;
        },
        get_sgzbh() {
            return this.editData.sgzbh;
        },
        attachCfg() {
            return {
                fktable: "RY_DJSQB",
                fkfield: "ID",
                fkvalue: this.editDataId,
                attachsource: "RY2000"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "ry_djsqb",
                fkvalue: this.editDataId
            };
        }
    },
    watch: {
        get_gddh(val) {
            if (val) {
                this.editData.gddh = val.replace(/[^0-9-]/g, "");
            }
        },
        get_yddh(val) {
            if (val) {
                this.editData.yddh = val.replace(/\D/g, "");
            }
        },
        get_zjhm(val) {
            if (val) {
                this.editData.zjhm = val.replace(/[^A-Za-z0-9]/g, "");
            }
        },
        get_sgzbh(val) {
            if (val) {
                this.editData.sgzbh = val.replace(/[^A-Za-z0-9]/g, "");
            }
        }
    },
    activated() {
        if (!this.editDataId) {
            this.editDataId = this.$FG_util.uuid();
            this.$FG_helper.handleNewBillCode("DJSQBBH").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.editDataId,
                    isnew: true,
                    djsqbbh: val,
                    djlxid: "DJSQB",
                    qyid: this.getUserInfo.companyInfo.qyid,
                    qybh: this.getUserInfo.companyInfo.qybh,
                    qymc: this.getUserInfo.companyInfo.qymc,
                    ssdwid: this.getUserInfo.companyInfo.id,
                    ssdwbh: this.getUserInfo.companyInfo.dwbh,
                    ssdwmc: this.getUserInfo.companyInfo.dwmc,
                    zcdwid: this.getUserInfo.companyInfo.id,
                    zcdwbh: this.getUserInfo.companyInfo.dwbh,
                    zcdwmc: this.getUserInfo.companyInfo.dwmc,
                    zjlx: "身份证",
                    zczq: 3,
                    bmid: this.getUserInfo.org_id,
                    ryid: this.getUserInfo.personnel_id,
                    yhid: this.getUserInfo.id,
                    lrbmmc: this.getUserInfo.org_name,
                    lrr: this.getUserInfo.personnel_name,
                    sczcsj: null,
                    xczcsj: null,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    djzt: "制定"
                };
                this.tableData = [];
                this.editItemPXJLData = [];
            });
        } else {
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.xm.focus();
        });
    },
    methods: {
        saveEvent_qybh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.qyid = val[0][0].ID;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qybh = val[0][0].QYBH;
            }
        },
        saveEvent_ssdwbh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.ssdwid = val[0][0].ID;
                this.editData.ssdwbh = val[0][0].DWBH;
                this.editData.ssdwmc = val[0][0].DWMC;
            }
        },
        saveEvent_zcdwbh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zcdwid = val[0][0].ID;
                this.editData.zcdwbh = val[0][0].DWBH;
                this.editData.zcdwmc = val[0][0].DWMC;
            }
        },
        saveEvent_zzy(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zzy = val[0][0].ZYMC;
            }
        },
        saveEvent_fzy(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.fzy = val[0][0].ZYMC;
            }
        },
        disabledDate(current) {
            return current && current > moment().startOf("day");
        },
        onChange(e) {
            let d1 = new Date(e).setFullYear(new Date(e).getFullYear() + 3);
            this.editData.xczcsj = this.$FG_util.formatDate(d1, "YYYY-MM-DD");
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.loadItemPXJLData();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemPXJLData() {
            this.editItemPXJLData = [];
            this.editItemPXJLDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/listPXJL",
                    {
                        jsryid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemPXJLDataLoading = false;
                    if (success) {
                        this.editItemPXJLData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 获取数据
            let itemData = this.$refs.itemPXJLTable.getTableData().tableData;
            let itemRemovedData = [];
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.xm.focus());
                    return;
                }
                if (!this.editData.xb) {
                    this.$FG_message.error("P0001", "性别").then(() => this.$refs.xb.focus());
                    return;
                }
                if (!this.editData.mz) {
                    this.$FG_message.error("P0001", "民族").then(() => this.$refs.mz.focus());
                    return;
                }
                if (!this.editData.csrq) {
                    this.$FG_message.error("P0001", "出生日期").then(() => this.$refs.csrq.focus());
                    return;
                }
                if (!this.editData.zjlx) {
                    this.$FG_message.error("P0001", "证件类型").then(() => this.$refs.zjlx.focus());
                    return;
                }
                if (!this.editData.zjhm) {
                    this.$FG_message.error("P0001", "证件号码").then(() => this.$refs.zjhm.focus());
                    return;
                }
                if (!this.editData.rylb) {
                    this.$FG_message.error("P0001", "人员类别").then(() => this.$refs.rylb.focus());
                    return;
                }
                if (!this.editData.byyx) {
                    this.$FG_message.error("P0001", "毕业院校").then(() => this.$refs.byyx.focus());
                    return;
                }
                if (!this.editData.bysj) {
                    this.$FG_message.error("P0001", "毕业时间").then(() => this.$refs.bysj.focus());
                    return;
                }
                if (!this.editData.sxzy) {
                    this.$FG_message.error("P0001", "所学专业").then(() => this.$refs.sxzy.focus());
                    return;
                }
                if (!this.editData.xl) {
                    this.$FG_message.error("P0001", "学历").then(() => this.$refs.xl.focus());
                    return;
                }
                if (!this.editData.cjgzsj) {
                    this.$FG_message.error("P0001", "参加工作时间").then(() => this.$refs.cjgzsj.focus());
                    return;
                }
                if (!this.editData.zczt) {
                    this.$FG_message.error("P0001", "登记状态").then(() => this.$refs.zczt.focus());
                    return;
                }
                if (this.editData.csrq >= this.$FG_util.formatDate(new Date(), "YYYY-MM-DD")) {
                    this.$FG_message.error("RY200005", "出生日期").then(() => this.$refs.csrq.focus());
                    return;
                }
                if (this.editData.pzsj < this.editData.csrq) {
                    this.$FG_message.error("RY200007", "批准时间").then(() => this.$refs.pzsj.focus());
                    return;
                }
                if (this.editData.bysj < this.editData.csrq) {
                    this.$FG_message.error("RY200008", "毕业时间").then(() => this.$refs.bysj.focus());
                    return;
                }
                if (this.editData.cjgzsj < this.editData.csrq) {
                    this.$FG_message.error("RY200009", "参加工作时间").then(() => this.$refs.cjgzsj.focus());
                    return;
                }
                if (this.editData.zczt === "已登记") {
                    if (!this.editData.zyzgzsbh) {
                        this.$FG_message.error("P0001", "执业资格证书编号").then(() => this.$refs.zyzgzsbh.focus());
                        return;
                    }
                    if (!this.editData.zcsj) {
                        this.$FG_message.error("P0001", "登记时间").then(() => this.$refs.zcsj.focus());
                        return;
                    }
                    if (!this.editData.zcdwbh) {
                        this.$FG_message.error("P0001", "登记单位编号").then(() => this.$refs.zcdwbh.focus());
                        return;
                    }
                    if (!this.editData.zcdwmc) {
                        this.$FG_message.error("P0001", "登记单位名称").then(() => this.$refs.zcdwmc.focus());
                        return;
                    }
                }

                for (let i = 0; i < itemData.length; i++) {
                    if (!itemData[i].bjmc) {
                        this.$FG_message.error("P0001", "班级名称").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].bjlb) {
                        this.$FG_message.error("P0001", "班级类别").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].ksrq) {
                        this.$FG_message.error("P0001", "报名开始日期").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].jsrq) {
                        this.$FG_message.error("P0001", "报名结束日期").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].pxksrq) {
                        this.$FG_message.error("P0001", "培训开始日期").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].pxjsrq) {
                        this.$FG_message.error("P0001", "培训结束日期").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].pxnr) {
                        this.$FG_message.error("P0001", "培训内容").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].pxdd) {
                        this.$FG_message.error("P0001", "培训地点").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].xs && itemData[i].xs !== 0) {
                        this.$FG_message.error("P0001", "学时").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].sfhg) {
                        this.$FG_message.error("P0001", "是否合格").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                    if (!itemData[i].zsbh) {
                        this.$FG_message.error("P0001", "证书编号").then(() => this.$refs.itemPXJLTable.setActiveRow(itemData[i]));
                        return;
                    }
                }
            }

            // 保存操作

            this.saving = true;
            //let isSuccess = false;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/save",
                    {
                        data: this.editData,
                        itemData,
                        itemRemovedData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        //isSuccess = true;
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.loadItemPXJLData();
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.xm.focus();
                    }
                });
        },
        showZzy() {
            this.editData.zzy = null;
            this.isShow_zzy = true;
        },
        showFzy() {
            this.editData.fzy = null;
            this.isShow_fzy = true;
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/jsrydj/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.xm.focus();
                            }
                        });
                }
            });
        },
        // 新增明细
        insertPXJL() {
            let xh = this.$refs.itemPXJLTable.getTableData().tableData.length + 1;
            // 设置编辑记录
            this.$refs.itemPXJLTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        djsqbid: this.editData.id,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemPXJLTable.setActiveRow(row);
                });
        },
        // 删除明细
        removePXJL(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemPXJLTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/jsry/jsrydj/deleteMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemPXJLData();
                                }
                            });
                    }
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        }
    }
};
</script>
